var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pickup-info-container"},[_c('h2',{staticClass:"header",class:{ 'has-error': _vm.hasError },attrs:{"tabindex":"0","role":"heading","aria-level":"2"}},[_vm._v("Pickup Info")]),(_vm.hasError)?_c('div',{staticClass:"error",attrs:{"role":"alert"}}):_vm._e(),_c('cmg-checkout-guest-info-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }